module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"kai kamera","short_name":"kai","start_url":"/","background_color":"#000","theme_color":"#f9c806","display":"minimal-ui","icon":"static/icons/favicon.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"11096aab566dec40a8231aa62ee20918"},
    }]
